import React from "react";

function Intro() {
  return (
    <div className="intro">
      <div className="copy">
        <h1>Lova Jormfeldt</h1>
        <div>Web developer</div>
      </div>
      <img src="img/lovalogo-blackbg.png" alt="logo" width="75px" />
    </div>
  );
}

export default Intro;
